import { Expose, Type } from '@nts/std/serialization';
import { PanelMetaData } from "./panel-meta-data";
import { ExtraLayoutMetaData } from './extra-layout-meta-data';
import { ExtraLayoutMetaDataInterface, LayoutMetaDataInterface, PanelMetaDataInterface } from '@nts/std/interfaces';

export class LayoutMetaData implements LayoutMetaDataInterface {

    constructor() {
        this.panels = [];
        this.extraFields = new ExtraLayoutMetaData();
    }

    @Expose()
    @Type(() => PanelMetaData)
    panels: PanelMetaDataInterface[];

    @Expose()
    @Type(() => ExtraLayoutMetaData)
    extraFields: ExtraLayoutMetaDataInterface;

}
